import { state, getFollowUpState, submitFollowUpDateConfirm } from "./followUpDateConfirm";

export default {
  submitFollowUpDateConfirm,
  state,
  getFollowUpState
};
